export const PROVIDE_FEEDBACK_URL = "https://forms.office.com/Pages/ResponsePage.aspx?id=HS1kjAnXsEerEAgK8QeY-_L1XDWsb4BLmo7XQY4WUZBUMjRPMzBPWDEzRVFVRTRBUTFBTjNFNDdXSyQlQCN0PWcu"
